<template>
        <AdminHeader />
</template>

<script>
import axios from '@/api/axios.js';
import AdminHeader from '@/components/AdminHeader.vue';

export default {
    components: {
        AdminHeader
    },
    data() {
        return {
        };
    },
    methods: {

    }
};
</script>
